@if (warranty) {
  <div class="background_body">
    <cx-page-slot position="EligibilityCheck" class=""></cx-page-slot>
    <form [formGroup]="warrantyEligibilityCheckForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
      <div class="myProfileformContainer fs-20" [ngClass]="isMobile ? '' : 'mb-3'">
        <div
          class="col-xs-12 d-flex col-sm-12 col-md-12 col-lg-12 warranty-form-container">
          <label class="mr-3 col-xs-12 col-sm-12 col-md-12 col-lg-6 warranty-form-label form-group">
            <span class="label-content">{{ 'common.text_core_search_partnum' | cxTranslate }}*</span>
            <input type="text" maxlength="255" class="form-control" placeholder="" formControlName="partNumber" />
            @if (warrantyEligibilityCheckControls.partNumber?.touched &&
              warrantyEligibilityCheckControls.partNumber?.errors &&
              warrantyEligibilityCheckControls.partNumber?.errors['required'] &&
              isSubmitted) {
              <div>
                <span class="text-danger-show-warr-info">
                  {{ 'common.general_required' | cxTranslate }}
                </span>
              </div>
            }
            @if (productNotFound) {
              <div class="mt-2 text-danger">
                <b>{{ productNotFound | cxTranslate }}</b>
              </div>
            }
          </label>
          <label class="mr-3 pl-0 col-xs-12 col-sm-12 col-md-12 col-lg-6 warranty-form-label form-group">
            <span class="label-content">
              {{ 'common.warranty_eligibility_check_mileage_in_service' | cxTranslate }}
            </span>
            <input type="text" maxlength="255" class="form-control" [attr.placeholder]="" formControlName="mileageInService" />
            @if (warrantyEligibilityCheckControls.mileageInService?.touched &&
              warrantyEligibilityCheckControls.mileageInService?.errors &&
              warrantyEligibilityCheckControls.mileageInService?.errors['required'] &&
              isSubmitted) {
              <div>
                <span class="text-danger-show-warr-info">
                  {{ 'common.general_required' | cxTranslate }}
                </span>
              </div>
            }
          </label>
        </div>
        <div class="d-flex col-12 warranty-form-container">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 warranty-select-block form-group">
            <label for="titleCode" class="control-label">
              {{ 'common.warranty_eligibility_check_type_of_operation' | cxTranslate }}
            </label>
            <div class="select-box warranty-select-box">
              <select name="country" class="form-control" formControlName="typeOfOperation">
                <option value="null" disabled selected>{{ 'common.form_select_empty' | cxTranslate }}</option>
                @for (item of warranty; track item; let i = $index) {
                  <option [value]="item.code">
                    {{ item.name }}
                  </option>
                }
              </select>
            </div>
            @if (warrantyEligibilityCheckControls.typeOfOperation?.touched &&
              warrantyEligibilityCheckControls.typeOfOperation?.errors &&
              warrantyEligibilityCheckControls.typeOfOperation?.errors['required'] &&
              isSubmitted) {
              <div>
                <span class="text-danger-show-warr-info">
                  {{ 'common.general_required' | cxTranslate }}
                </span>
              </div>
            }
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 d-flex align-items-end warranty-date-block warranty-space">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 pl-lg-0 warranty-date-block form-group">
              <label for="titleCode" class="control-label">
                {{ 'common.text_warranty_submit_part_datein_service' | cxTranslate }}
              </label>
              <input
                class="form-control bsdpicker kb-datePickerIcon"
                bsDatepicker
                formControlName="inServiceString"
                [maxDate]="bsDate"
                placeholder="mm/dd/yyyy"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', showWeekNumbers: false, displayOneMonthRange: true }"
                [daysDisabled]="[6, 0]"
                />
                @if (warrantyEligibilityCheckControls.inServiceString?.touched &&
                  warrantyEligibilityCheckControls.inServiceString?.errors &&
                  warrantyEligibilityCheckControls.inServiceString?.errors['required'] &&
                  isSubmitted) {
                  <div>
                    <span class="text-danger-show-warr-info">{{ 'common.general_required' | cxTranslate }}</span>
                  </div>
                }
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 warranty-date-block form-group warranty-right-date-block">
                <label for="titleCode" class="control-label">
                  {{ 'common.warranty_eligibility_check_date_removed_from_service' | cxTranslate }}*
                </label>
                <input
                  class="form-control bsdpicker kb-datePickerIcon"
                  bsDatepicker
                  formControlName="removedFromServiceString"
                  [maxDate]="bsDate"
                  placeholder="mm/dd/yyyy"
                  [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', showWeekNumbers: false, displayOneMonthRange: true }"
                  [daysDisabled]="[6, 0]"
                  />
                  @if (warrantyEligibilityCheckControls.removedFromServiceString?.touched &&
                    warrantyEligibilityCheckControls.removedFromServiceString?.errors &&
                    warrantyEligibilityCheckControls.removedFromServiceString?.errors['required'] &&
                    isSubmitted) {
                    <div>
                      <span
                        class="text-danger-show-warr-info">
                        {{ 'common.general_required' | cxTranslate }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div
              class="form-group d-flex alignbtnend col-xs-12 col-sm-12 col-md-12 warranty-date-block warranty-bottom-row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 warranty-date-block form-group">
                <label for="postalCode">
                  {{ 'common.warranty_eligibility_check_vehicle_identification_number' | cxTranslate }}
                </label>
                <input type="text" maxlength="17" formControlName="vehicleId" class="form-control" name="vehicleId" />
                <div></div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 pl-lg-0 warranty-date-block">
                <div class="warranty-date-block warranty-buitton-block">
                  <button class="btn btn-primary mb-1 fs-24 px-4" [ngClass]="isMobile ? '' : ''" type="submit">
                    {{ 'common.text_warranty_submit_button' | cxTranslate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    }
